import client from '../../../../lib/client';
import { constructParams } from '../../../../lib/helper';
import { ENDPOINT } from '../constants';

function listAcademicYear(params) {
  return client.get(`${ENDPOINT}${constructParams(params)}`);
}

function createAcademicYear({
  years,
  semester,
  startSemester,
  endSemester,
  description,
}) {
  return client.post(ENDPOINT, {
    years,
    semester,
    startSemester,
    endSemester,
    description,
  });
}

function updateAcademicYear({
  id,
  years,
  semester,
  startSemester,
  endSemester,
  description,
}) {
  const academicYearsId = id;
  return client.put(`${ENDPOINT}/${academicYearsId}`, {
    years,
    semester,
    startSemester,
    endSemester,
    description,
  });
}

function showAcademicYear(id) {
  return client.get(`${ENDPOINT}/${id}`);
}

function deleteAcademicYear(id) {
  return client.delete(`${ENDPOINT}/${id}`);
}

export {
  listAcademicYear,
  createAcademicYear,
  updateAcademicYear,
  showAcademicYear,
  deleteAcademicYear,
};
